const React = require("react");
const T = React.PropTypes;

const baseStyle = {
    padding: "7px 8px 8px 8px",
    color: "#fff",
    borderRadius: "50%",
    boxShadow: "0 3px 5px #888"
};

const CompletedMark = React.createClass({
    propTypes: {
        onClick: T.func,
        style: T.object
    },
    getDefaultProps() {
        return {
            style: {}
        };
    },
    render() {
        const iconStyle = Object.assign(baseStyle, { top: 0, backgroundColor: "#fd0" });

        return (<div style={this.props.style}>
            <span className="glyphicon glyphicon-ok bg-danger" style={iconStyle}></span>
        </div>);
    }
});

module.exports = CompletedMark;


// WEBPACK FOOTER //
// ./src/components/CompletedMark.jsx